import EditableDropdown from '@/common/EditableDropdown';
import { BackWeightData, BackWeightFields, getBackWeightLocation, getBackWeightNumbers, selectBackWeight } from '@/library/BackWeightHelper';

interface BackWeightDropdownProps {
  headModelId?: number;
  value: BackWeightFields;
  data: BackWeightData;
  // eslint-disable-next-line no-unused-vars
  onChange: (value: BackWeightFields) => void;
  className?: string;
}

export const BackWeightDropdown = ({ headModelId, value, data, onChange, className }: BackWeightDropdownProps) => {
  const location = getBackWeightLocation(headModelId, data);
  const numbers = getBackWeightNumbers(headModelId, data);
  const options = location ? numbers.map((number) => ({ id: number.headWeightNumberLookupId.toString(), label: number.name })) : [];

  return (
    <EditableDropdown
      label="Back Wt"
      initialId={value.headWeightNumberBackLookupId?.toString() || ''}
      options={options}
      onChange={(id) => onChange(selectBackWeight(headModelId, id, data))}
      allowClear
      className={className}
    />
  );
};
